<div class="carousel-container">

  <img [class.hidden]="position == 0" alt="" class="more-arrow arrow-left" src="./assets/images/left_arrow.png" (click)="moveLeft()">

  <div class="carousel-content">

    <div #carouselCategoryDiv class="category" [style.margin-left.px]="carouselMarginLeft">
      <app-grid-item class="item" *ngFor="let item of items[categories[0]]"
        [item]="item" [priceHint]="'home'" [isCarouselItem]="true" [store]="title" [showFooterTop]="false"
        (onWishlistClicked)="addToWishlist(item)"
        (onOwnlistClicked)="addToOwnlist(item)"
        (onBlocklistClicked)="addToBlocklist(item)"
        >
      </app-grid-item>

    </div>

    <ng-container *ngFor="let key of categories; let i = index">
      <div class="category" *ngIf="i != 0">
        <app-grid-item class="item" *ngFor="let item of items[key]"
          [item]="item" [priceHint]="'home'" [isCarouselItem]="true" [store]="title" [showFooterTop]="false"
          (onWishlistClicked)="addToWishlist(item)"
          (onOwnlistClicked)="addToOwnlist(item)"
          (onBlocklistClicked)="addToBlocklist(item)"
          >
        </app-grid-item>

      </div>

    </ng-container>
  </div>

  <img [class.hidden]="position == itemCount - 1" alt="" class="more-arrow" src="./assets/images/right_arrow.png" (click)="moveRight()">

</div>
